module.exports = __webpack_public_path__ + "media/images/icons/busca-fechas-f4eb3f686f5abd570f19b43053a2a1d5.svg";